import React, { useRef } from "react";
import { useProductListForBuying } from "hooks";
import { ProductShortened } from "types";
import { CustomReactTableHandles } from "core";
import { BoxHeadlineContainer } from "layout/Container/BoxHeadlineContainer";
import { Routes } from "routes";
import { ProductToBuyListFilter } from "../ProductToBuyListFilter";
import { ProductToBuyListTable } from "../ProductToBuyListTable";

const ProductToBuyListPage: React.FC = () => {
  const { isLoading, productList, allProductList } = useProductListForBuying();

  const productTableRef =
    useRef<CustomReactTableHandles<ProductShortened>>(null);

  return (
    <BoxHeadlineContainer
      boxTitle="Einkauf"
      boxIcon={Routes.products.icon}
      boxSubTitle={productList.length.toString()}
      paddingHorizontal={0}
      paddingVertical={0}
      boxAlignment="center"
      boxWidth="lg"
      marginTop={false}
    >
      <ProductToBuyListFilter productList={allProductList} />
      <ProductToBuyListTable
        isLoading={isLoading}
        productList={productList}
        productTableRef={productTableRef}
      />
    </BoxHeadlineContainer>
  );
};

export default ProductToBuyListPage;
